import React, { useEffect, useState } from "react";
import { Link, useHistory } from "react-router-dom"
import axios from "axios";
import Avatar from '@mui/material/Avatar';
import { Button, TextField } from '@mui/material';
import CssBaseline from '@mui/material/CssBaseline';
import swal from "sweetalert";
import Swal from 'sweetalert2'
import FormControlLabel from '@mui/material/FormControlLabel';
import Checkbox from '@mui/material/Checkbox';
import Grid from '@mui/material/Grid';
import Box from '@mui/material/Box';
import LockOutlinedIcon from '@mui/icons-material/LockOutlined';
import Typography from '@mui/material/Typography';
import Container from '@mui/material/Container';
import EmsNavbar from "../../frontend/EmsNavbar";
import ExhibitionNavbar from "../../frontend/Exhibition/NewVersion/ExhibitionNavbar";
import NewVersionAbstractFooter from "../AbstractAuth/NewVersion/NewVersionAnstractFooter";
import { useMediaQuery, useTheme } from '@mui/material';


const Verifiction = () => {
    const history = useHistory();
    const [emailexist, setemailexist] = useState({
        email: "",
        error_list: [],
    });
    const [exhibitionEmailFind, setExhibitionEmailFind] = React.useState([]);
    const eventid = localStorage.getItem('eventid');
    const theme = useTheme();
    const isSmallScreen = useMediaQuery(theme.breakpoints.down('sm'));
    const gradientBackground = '#05597D';
    const [isButtonDisabled, setIsButtonDisabled] = useState(true);
    const [abstractHomeSetup, setAbstractHomeSetup] = useState({
        color_code: "",
        color_code_two: "",
        color_code_three: "",
        call_emergency: "",
        send_email: "",
        event_place: "",
        facebook_link: "",
        Instagram_link: "",
        linkedin_link: "",
        twitter_link: "",
        abstractFooterImage: "",
        abstractBannerImage: "",
        workshopBannerImage: "",
        abstractSponserLogos: "",
        event_name: "",
        error_list: [],
    });
    React.useEffect(() => {
            axios.get(`api/add-home-setup-index?id=${eventid}`).then(res => {
                if (res.status === 200) {
                    const getHomePageData = res.data.HomePageSetup;
                    setAbstractHomeSetup(getHomePageData);
                }
            })
    }, [eventid]);
    // const handleInput = (e) => {
    //     e.persist();
    //     setemailexist({ ...emailexist, [e.target.name]: e.target.value });
    // }
   
    useEffect(() => {
        // Disable the button initially if the email is not valid or empty
        setIsButtonDisabled(Boolean(emailexist.error_list?.email) || emailexist?.email === "");
    }, [emailexist.error_list?.email, emailexist?.email]);


    const handleInput = (e) => {
        e.persist();
        const { name, value } = e.target;
        setemailexist({ ...emailexist, [name]: value });

        // Email validation
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        if (name === 'email' && value) {
            if (!emailRegex.test(value)) {
                setemailexist(prevState => ({
                    ...prevState,
                    error_list: { ...prevState.error_list, email: 'Please enter a valid email address' }
                }));
            } else {
                setemailexist(prevState => ({
                    ...prevState,
                    error_list: { ...prevState.error_list, email: '' }
                }));
                setIsButtonDisabled(false);
            }
        }
    };

    React.useEffect(() => {
        axios.post(`api/useremailfind?id=${eventid}`).then(res => {

            if (res.status === 200) {
                const searchingEmain = res.data.email;
                setExhibitionEmailFind(searchingEmain)

            } else {
                swal('Error', "Check API Something Wrong", 'error');

            }
        })

    }, []);
    const handleSubmit = (e) => {
        e.preventDefault();
        const data = {
            email: emailexist.email,
            eventid,
        }

        if (emailexist.email != "") {
            localStorage.setItem('exhibition_email', emailexist.email);

        }
        axios.get('/sanctum/csrf-cookie').then(response => {

            axios.post(`api/useremailfind`, data).then(res => {
                if (res.data.redirect == 0) {
                    swal("Success", res.data.message, "success")
                    history.push('/exhibition/email-found');
                    return false;
                }
                if (res.data.redirect == 1) {
                    history.push('/exhibition/guest-form');
                    return false;
                }
                if (res.data.verify_status == 0) {
                    history.push({
                        pathname: '/exhibition/email-found',
                        state: { verifyStatus: res.data.verify_status }
                      });
                    return false;
                }
                else {
                    setemailexist({ ...emailexist, error_list: res.data.validate_error });

                }
            })
        });


    };
    return (
        <div>
        <Grid item xs={12} sm={10} md={8} lg={6}>
            <ExhibitionNavbar />
        </Grid>
        <Grid container spacing={2}>
            <Box
                sx={{
                    position: 'relative',
                    marginTop: '10px',
                    width: '100%',
                    height: isSmallScreen ? '200px' : '400px', // Adjust height for small screens
                    //backgroundImage: `url(${bannerImage})`,
                    backgroundImage: `url(${abstractHomeSetup.workshopBannerImage})`,
                    backgroundSize: 'cover',
                    backgroundPosition: 'center',
                    display: 'flex',
                    alignItems: 'flex-end',
                    justifyContent: isSmallScreen ? 'center' : 'left',
                    padding: isSmallScreen ? '10px' : '20px', // Adjust padding for small screens
                    color: 'white',
                }}
            >
                <Typography variant={isSmallScreen ? 'h6' : 'h2'} component="div">
                    Exhibition Management System
                </Typography>
            </Box>

            <Grid container justifyContent="center" marginTop="40px">
                <Grid item xs={12} sm={10} md={8} lg={6}>
                    <Box component="form" onSubmit={handleSubmit}
                        sx={{
                            boxShadow: 3,
                            borderRadius: 2,
                            padding: 4,
                            width: '100%',
                            maxWidth: isSmallScreen ? '300px' : '600px', // Initial maxWidth for smaller screens
                            textAlign: 'center',
                            background: abstractHomeSetup.color_code_four
                            ? abstractHomeSetup.color_code_four
                            : gradientBackground,
                            color: 'white', 
                            marginX: 'auto', 
                            '@media (min-width: 960px)': {
                                maxWidth: '800px', // Increase maxWidth on larger screens if needed
                            },
                        }}
                    >
                        <Typography component="h1" variant="h5">
                            Verify your Email
                        </Typography>

                        <TextField
                            margin="normal"
                            required
                            fullWidth
                            autoComplete="off"
                            id="email"
                            label="Email Address"
                            name="email"
                            autoFocus
                            onChange={handleInput} value={emailexist?.email}

                            helperText={emailexist.error_list?.email}
                            InputLabelProps={{
                                style: { color: 'white' }, // Set label text color
                            }}
                            FormHelperTextProps={{
                                style: { color: 'white' }, // Set helper text color
                            }}
                            InputProps={{
                                style: {
                                    color: 'white', // Set text color inside the input
                                    '&::placeholder': {
                                        color: 'white', // Set placeholder text color
                                        opacity: 0.7, // Adjust opacity if needed
                                    },
                                },
                            }}
                            InputLabelProps={{
                                sx: {
                                    color: 'white', // Set label text color
                                },
                            }}
                            sx={{
                                '& .MuiOutlinedInput-root': {
                                    borderRadius: '25px', // Adjust the value as needed
                                    color: 'white', // Set text color inside the input field
                                    '& fieldset': {
                                        borderColor: 'white', // Set border color for the input
                                    },
                                    '&:hover fieldset': {
                                        borderColor: 'white', // Set border color on hover
                                    },
                                    '&.Mui-focused fieldset': {
                                        borderColor: 'white', // Set border color when focused
                                    },
                                },
                                '& .MuiInputLabel-root': {
                                    color: 'white !important', // Ensure label text color is white
                                },
                                '& .MuiFormHelperText-root': {
                                    color: 'white !important', // Ensure helper text color is white
                                },
                            }} />

                        <Button
                            type="submit"
                            fullWidth
                            variant="contained"
                            disabled={isButtonDisabled}
                            sx={{
                                mt: 3,
                                mb: 2,
                                background: abstractHomeSetup.color_code_two
                                ? abstractHomeSetup.color_code_two
                                : gradientBackground,
                                borderRadius: '25px', // Adjust the value as needed
                            }}
                        >
                            Verify
                        </Button>
                    </Box>
                </Grid>
            </Grid>
        </Grid>
        <Grid item xs={12} sm={10} md={8} lg={6} marginTop="40px">
            <NewVersionAbstractFooter />
        </Grid>
    </div>
    );
}

export default Verifiction;
